export const COMPONENT_ID_METADATA_KEY = 'digitaix/core/component/ID';
export const COMPONENT_DEFINITION_METADATA_KEY = 'digitaix/core/component/DEFINITION';
